import Call from '../Call';
import {objToQs} from "../Utils";

const Payout = {
    getPage(pageNum, search) {
        return Call(`payout/${pageNum}?${objToQs({search})}`);
    },

    save(payout) {
        return Call('payout','POST',payout);
    },

    remove(affid) {
        return Call(`payout/${affid}`,'DELETE');
    }
};

export default Payout;


// WEBPACK FOOTER //
// ./src/services/API/components/Payout.js